import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductPhotoModalComponent } from '../dialogs/product-photo-modal/product-photo-modal.component';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HostListener } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { contentReady } from '@syncfusion/ej2-angular-grids';
import { finalize, map } from 'rxjs/operators';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { PageEvent } from '@angular/material/paginator';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { SpinnerOverlayComponent } from '../dialogs/spinner-overlay/spinner-overlay.component';

@Component({
  selector: 'app-reportages-photos',
  templateUrl: './reportages-photos.component.html',
  styleUrls: ['./reportages-photos.component.sass']
})
export class ReportagesPhotosComponent implements OnInit {
  screenHeight: number;
  screenWidth: number;

  mobileView: boolean;
  mobileSummaryStepper: boolean;
  mobileLandscapeImage: boolean;
  mobileSummaryItems: boolean;
  loading: boolean = true;
  tpv_payment: boolean = true;
  price: number;
  floatingButtonExtend: boolean = false;
  pageEvent: PageEvent;
  productSelected: string;
  lets_continue = false;
  reportagesListSubs: Subscription;
  reportages: any = [];
  url_list: any;
  products: any = [];
  totalItems: any;
  msg: any = [];
  reportage_photo: any;
  photoURLArray: any[] = [];
  photoURLObject: any = {};
  private routeSub: Subscription;
  showProductsGrid: boolean = false;
  productAlbumId: string;
  showPrimarySpinner: boolean = false;
  showSecondarySpinner: boolean = false;
  showProductListLoadingSpinner: boolean = true;

  highlightedProducts: any = [];
  nonHighlightedProducts: any = [];


  showReservationSummary: boolean = false;

  // For product table
  // Data source is products variable
  displayedColumns: string[] = ['photo', 'description'];
  checkoutSummaryColumnsTitle: string[] = ['title'];
  checkoutSummaryColumns: string[] = ['photo-summary', 'product', 'grade', 'reportage', 'unit_pvp', 'quantity' /*, 'pvp'*/];
  CheckoutDataSource: any[];
  data=[]
  prodQtyOverview: any = {};
  selectedProducts: any[] = [];
  totalValueAmount: any = { 'amount': 0, 'currency': '€' };
  page = 0;
  size = 100;
  selectedLanguage: string = 'es';
  numberList: any[];
  selected: any;
  // To store different product descriptions
  productDescriptions: any = {};
  highlightedProductDescriptions: any = {}
  headerData: any = [];
  headerLoaded: boolean = false;

  updatingShoppingCart: any = { updating: false, itemId: '' };

  badgeNumber: any = 0;
  total_products: any = 0;

  reservationDataForm: FormGroup;

  title: string;
  ok_txt: string;
  message: string;

  public albumSelection: any[] = []
  public albumSelectionIdList: any[] = []
  public activePhotoSelection: any = null
  public albumMin: any = 0
  public albumMax: any = 0

  @ViewChild('stepper') stepper;
  stepperIndex: Number = 0


  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public dialog: MatDialog,
    public router: Router,
    private snackbar: MatSnackBar,
    private fb: FormBuilder

  ) {

    this.numberList = Array(10).fill(1).map((x, i) => i + 1);

    this.getScreenSize();

    this.reservationDataForm = fb.group({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      id_num: new FormControl('', Validators.required),
      tel_num: new FormControl('', Validators.required),
      accept_conditions: new FormControl(false)
    })

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;

    this.screenWidth >= 1560 ? this.mobileSummaryItems = false : this.mobileSummaryItems = true;
    this.screenWidth >= 1100 ? this.mobileView = false : this.mobileView = true;
    this.screenWidth >= 765 ? this.mobileSummaryStepper = false : this.mobileSummaryStepper = true;
    this.screenWidth >= 510 ? this.mobileLandscapeImage = false : this.mobileLandscapeImage = true;

  }



  getRelatedProducts(reportage_id: string){
    this.dataService.getReportageRelatedProducts(reportage_id).subscribe(res =>{
      this.total_products = res.products_list.length

      res.products_list.forEach(item => {
        if (item.highlighted_reportage == true){
          this.highlightedProducts.push(item)
        }
        else{
          this.products.push(item)
        }
      })

      // this.products = res.products_list
      this.tpv_payment = res.tpv_payment
      this.msg = res.msg
      if (this.total_products > 0){
        this.changePrice(this.products[0])
      }

      this.selected = this.products[0]

      this.highlightedProducts.forEach(element => {
        let description = JSON.parse(element.description)

        this.highlightedProductDescriptions[element.id] = description;
      })

      this.products.forEach(element => {
        let description = JSON.parse(element.description)

        this.productDescriptions[element.id] = description;
      })


      if (res.tpv_payment){
        this.dataService.getTotalShoppingCart().subscribe(res => {

          if (res.status == "ok") {

            this.badgeNumber = res.total_products
          }

        })
      }
    })

  }

  // USE THIS FUNCTION TO GET CATALOGUE DATA -> MIN / MAX FOR ALBUM SELECTION
  // public getRelatedProduct(catalogueId: number){
  //   this.dataService.getRelatedProduct({"catalogue_id":catalogueId}).subscribe(res =>{
  //     
  //   })
  // }


  ngOnInit(): void {

    this.selectedLanguage = this.translate.currentLang
    this.showPrimarySpinner = true // Show primary spinner at beginning of loading process

    this.routeSub = this.route.params.subscribe(params => {

      this.dataService.getReportage(params.reportage_id).subscribe( res => {
        this.headerData = res;
        this.headerLoaded = true;
        this.msg['es'] = this.headerData.no_order_txt
        this.msg['cat'] = this.headerData.no_order_txt_cat
        this.msg['en'] = this.headerData.no_order_txt_en
      })

      if (params.reportage_id) {
        if (params.id != 'new') {
          this.getRelatedProducts(params.reportage_id)
          this.getTotalReportageProducts(params.reportage_id)

          let data = {}
          data['reportage_id'] = params.reportage_id
          data['size'] = 100
          data['page'] = 1
          this.reportagesListSubs = this.dataService
            .getReportagePhotos(data)
            .subscribe(res => {

              
              if (res['status'] == 'not authorized') {
                this.router.navigate(['/welcome']);
                return false;
              }
              else {
                this.showPrimarySpinner = false // Hide primary spinner once reportage content is loaded

                this.url_list = res;
                if (this.url_list.length == 0){
                  this.loading = false
                }
                let index = 1
                this.url_list.forEach(element => {
                  this.dataService.adminGetStudentPhoto(element.url).subscribe(item => {
                    if (item.status == 'success'){
                      item['id'] = element.id
                      item['name'] = element.name
                      item['tpv_payment'] = element.tpv_payment
                      this.reportages.push(item)
                      this.reportages.sort((a, b) => (a.name < b.name ? -1 : 1));
                      this.prodQtyOverview[element.id] = { 'unit': 1}
                      if (index == this.url_list.length){
                        this.loading = false

                      }
                      else{
                        index += 1

                      }
                    }

                  })


                });
                // this.getData({pageIndex: this.page, pageSize: this.size});
              }

            },
              console.error
            );
        }

      }
    });


  }

  getTotalReportageProducts(reportageID: string){
    this.dataService.getTotalReportageProducts(reportageID).pipe(
      map((totalItems) => this.totalItems = totalItems)
    ).subscribe()
  }

  onPaginateChange(event: PageEvent) {

    this.loading = true;
    this.reportages = []
    this.size = event.pageSize

    this.routeSub = this.route.params.subscribe(data => {
      var params = {};
      params['reportage_id'] = data.reportage_id
      params['page'] = event.pageIndex + 1
      params['size'] = this.size

      this.reportagesListSubs = this.dataService
      .getReportagePhotos(params)
      .subscribe(res => {

        
        if (res['status'] == 'not authorized') {
          this.router.navigate(['/welcome']);
          return false;
        }
        else {
          this.showPrimarySpinner = false // Hide primary spinner once reportage content is loaded

          this.url_list = res;
          let index = 1
          this.url_list.forEach(element => {
            this.dataService.adminGetStudentPhoto(element.url).subscribe(item => {
              if (item.status == 'success'){
                item['id'] = element.id
                item['name'] = element.name
                item['tpv_payment'] = element.tpv_payment
                this.reportages.push(item)
                this.reportages.sort((a, b) => (a.name < b.name ? -1 : 1));

                this.prodQtyOverview[element.id] = { 'unit': 1}
                if (index == this.url_list.length){
                  this.loading = false
                }
                else{
                  index += 1
                }
              }

            })


          });
          // this.getData({pageIndex: this.page, pageSize: this.size});
        }

      },
        console.error
      );
    });
  }
  // getData(obj) {
  //   let index=0,
  //       startingIndex=obj.pageIndex * obj.pageSize,
  //       endingIndex=startingIndex + obj.pageSize;

  //   this.data = this.reportages.filter(() => {
  //     index++;
  //     return (index > startingIndex && index <= endingIndex) ? true : false;
  //   });
  // }

  stepperIndexHandler(btnID: string){

    btnID == 'next' ? this.stepperIndex = 1 : this.stepperIndex == 0 ? this.proceedToReservationCheckout() : this.stepperIndex = 0

    this.stepper.selectedIndex = this.stepperIndex;

  }



  // Changes the number selected for each product before adding it to checkout
  productQuantitySelectHandler(newQuantity: any, productId: any) {

    this.prodQtyOverview[productId].unit = newQuantity;

  }

  changePrice(productID: any){
    this.productSelected = productID.id
    this.price = productID.value
  }
  // Adds product to reservation checkout
  addProductToCheckout(productId: any) {

    let checkoutData = [...this.selectedProducts];

    if (!this.selectedProducts.some(({ id }) => id === productId)) {

      let product = {
        id: productId,
        unit: this.prodQtyOverview[productId].unit,
        value: this.prodQtyOverview[productId].value,
        name_en: this.prodQtyOverview[productId].name_en,
        name_es: this.prodQtyOverview[productId].name_es,
        name_cat: this.prodQtyOverview[productId].name_cat,
        type: this.prodQtyOverview[productId].type,
      }

      checkoutData.push(product)


    } else {

      checkoutData.forEach(prod => {

        if (prod.id === productId) {
          prod.unit += this.prodQtyOverview[productId].unit
        }

      })

    }


    // TODO Substitute item for real item name in popup message.
    this.translate.get('buttons.dismiss').subscribe((res: string) => {

      let dismiss = res;

      this.translate.get('alerts.item_added_res').subscribe((res: string) => {

        let msg = res;

        this.snackbar.open(msg, dismiss, { duration: 2500 })

      })

    })

    this.selectedProducts = checkoutData
    this.prodQtyOverview[productId].unit = 1
    this.updateTotalValueAmount()

  }

  // Removes product form reservation checkout
  removeProductFromCheckout(productId) {

    let checkoutData = [];

    this.selectedProducts.forEach(product => {

      if (product.id !== productId) {
        checkoutData.push(product)
      }

    })

    // TODO Substitute item for real item name in popup message.
    this.translate.get('buttons.dismiss').subscribe((res: string) => {

      let dismiss = res;

      this.translate.get('alerts.item_removed_res').subscribe((res: string) => {

        let msg = res;

        this.snackbar.open(msg, dismiss, { duration: 2500 })

      })

    })

    this.selectedProducts = checkoutData;
    this.updateTotalValueAmount()

  }


  addToShoppingCart(photoID: any, price: string, productSelected) {

    let params = {}
    params['photoID'] = photoID
    params['productID'] = productSelected
    // params['action'] = action
    params['quantity'] = this.prodQtyOverview[photoID].unit
    this.route.params.subscribe(res => {
      params['reportageID'] = res.reportage_id
    })


    this.dataService.addRemoveReportageToShoppingCart(params).subscribe(res => {

      if (res.status == 'downloadablerepeat'){
        this.translate.get('buttons.dismiss').subscribe((res: string) => {

          let dismiss = res;

          this.translate.get('alerts.item_downloadable_repeat').subscribe((res: string) => {

            let msg = res;

            this.snackbar.open(msg, dismiss, { duration: 5000 ,panelClass: ['error-snackbar'] })

          })

        })
      }
      else if (res.status == 'ok_downloadable_max_1'){
        this.translate.get('buttons.dismiss').subscribe((res: string) => {

          let dismiss = res;

          this.translate.get('alerts.ok_downloadable_max_1').subscribe((res: string) => {

            let msg = res;

            this.snackbar.open(msg, dismiss, { duration: 5000 ,panelClass: ['error-snackbar'] })

          })

        })
        this.badgeNumber = res.total_products;
      }
      else{
        this.badgeNumber = res.total_products;

        this.translate.get('buttons.dismiss').subscribe((res: string) => {

          let dismiss = res;

          this.translate.get('alerts.item_added_cart').subscribe((res: string) => {

            let msg = res;

            this.snackbar.open(msg, dismiss, { duration: 2500 })

          })

        })
      }


    })

  }



  summaryProductQuantityHandler(newQty: any, productId: any) {

    if (newQty == 0) {

      this.removeProductFromCheckout(productId);

    } else {

      let newSelectedProducts = [...this.selectedProducts];

      newSelectedProducts.forEach(item => {

        if (item.id == productId) {

          item.unit = newQty;

        }

      })

      this.selectedProducts = newSelectedProducts;


    }

    this.updateTotalValueAmount();

  }


  // TODO Review this function's items param so it matches current format
  checkoutHandler(form: FormGroup) {
    if (!form.valid) {

      this.translate.get('buttons.dismiss').subscribe((res: string) => {

        let dismiss = res;

        this.translate.get('alerts.form_error').subscribe((res: string) => {

          let msg = res;

          this.snackbar.open(msg, dismiss, { duration: 5000, panelClass: ['error-snackbar'] })

        })

      })

      throw new Error('Invalid or missing form data')
    }

    if (form.value.accept_conditions != true) {
      this.translate.get('buttons.dismiss').subscribe((res: string) => {

        let dismiss = res;

        this.translate.get('alerts.conditions_required').subscribe((res: string) => {

          let msg = res;

          this.snackbar.open(msg, dismiss, { duration: 5000, panelClass: ['error-snackbar'] })


        })

      })
      return false;
    }


    this.translate.get('alerts.atention').subscribe(res => {
      this.title = res;
    })



    this.translate.get('buttons.ok').subscribe(res => {
      this.ok_txt = res;
    })


    this.dataService.checkReserve(this.reportages['id']).subscribe(res => {
      // alert(res);
      if (res == 'exists') {
        this.translate.get('alerts.more_reserves').subscribe(res => {
          this.message = res;
        })
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: this.title,
            message: this.message,
            ok_txt: this.ok_txt
          }
        }).afterClosed().subscribe(res => {

          if (res === true) {

            // this.lets_continue = true
            this.translate.get('alerts.confirm_reservation').subscribe(res => {
              this.message = res;
            })

            let dialogRef2 = this.dialog.open(ConfirmReservationDialogComponent, {
              data: {
                title: this.title,
                message: this.message + this.totalValueAmount.amount + this.totalValueAmount.currency,
                ok_txt: this.ok_txt
              }
            }).afterClosed().subscribe(res => {

              if (res === true) {

                let items = [];
                this.selectedProducts.forEach(element => {
                  items.push({ 'id': element.id, 'unit': element.unit, 'unit_value': element.value })
                });


                let params = {}
                params['name'] = form.value.name
                params['surname'] = form.value.surname
                // personal_info['name'] = `${form.value.surname} ${form.value.surname}`
                params['dni'] = form.value.id_num
                params['tel_num'] = form.value.tel_num
                // personal_info['accepted_conditions'] = form.value.accept_conditions /* Must always be true, error will be thrown otherwise on line 329 */

                params['school'] = this.reportages['school']._flat_path[1].toString();
                params['total'] = this.totalValueAmount.amount;
                params['reportagephoto_id'] = this.reportages['id'];
                params['items'] = JSON.stringify(items);

                this.dataService.createReserve(params).subscribe(res => {
                  this.translate.get('alerts.created_reservation').subscribe((res: string) => {
                    this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
                  })
                  this.router.navigate(['/orders']);
                })

              } else {
                // TODO Determine what happens if user cancels order here
              }

            })

          }
          else {
            // this.lets_continue = false
          }

        })
      }
      else {
        // this.lets_continue = true;
        this.translate.get('alerts.confirm_reservation').subscribe(res => {
          this.message = res;
        })

        let dialogRef2 = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: this.title,
            message: this.message + this.totalValueAmount.amount + this.totalValueAmount.currency,
            ok_txt: this.ok_txt
          }
        }).afterClosed().subscribe(res => {

          if (res === true) {

            let items = [];
            this.selectedProducts.forEach(element => {
              items.push({ 'id': element.id, 'unit': element.unit, 'unit_value': element.value })
            });



            let params = {}
            params['name'] = form.value.name
            params['surname'] = form.value.surname
            // personal_info['name'] = `${form.value.surname} ${form.value.surname}`
            params['dni'] = form.value.id_num
            params['tel_num'] = form.value.tel_num
            // personal_info['accepted_conditions'] = form.value.accept_conditions /* Must always be true, error will be thrown otherwise on line 329 */

            params['school'] = this.reportages['school']._flat_path[1].toString();
            params['total'] = this.totalValueAmount.amount;
            params['reportagephoto_id'] = this.reportages['id'];
            params['items'] = JSON.stringify(items);




            this.dataService.createReserve(params).subscribe(res => {
              this.translate.get('alerts.created_reservation').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
              })
              this.router.navigate(['/orders']);
            })

          } else {
            // TODO Determine what happens if user cancels order here
          }

        })
      }


    })









  }



  openPhotoPreview(image_url: string) {

    let dialogRef = this.dialog.open(ProductPhotoModalComponent, {
      // maxWidth: '800px',
      // width: '92%',
      // maxHeight: '80%',
      backdropClass: 'photo-dialog-backdrop',
      panelClass: 'photo-dialog',
      data: image_url
    })
  }


  // Updates total value sum of all products selected.
  updateTotalValueAmount() {
    let totalAmount = 0;
    let totalItems = 0;
    this.selectedProducts.forEach(element => {
      totalAmount += (element.unit * element.value)
      totalItems += element.unit
    })
    this.totalValueAmount['amount'] = totalAmount.toFixed(2);
    this.badgeNumber = totalItems
  }


  doNotCloseMenu($event: any) {
    $event.stopPropagation();
  }




  goTo(route: string) {

    this.router.navigate([route]);

  }


  proceedToReservationCheckout() {

    this.showReservationSummary = !this.showReservationSummary;
    this.floatingButtonExtend = false

  }

  hoverOn(button: string) {

    this.floatingButtonExtend = true

  }

  hoverOff(button: string) {

    this.floatingButtonExtend = false

  }


  // TODO Convert this into a toggle to allow close from this function also
  public toggleAlbumPhotosSelector(productAlbumId: string = ''){
    if(productAlbumId==''){
      this.showProductsGrid = false
      this.productAlbumId = ''
      this.albumMax = 0
      this.albumMin = 0
      this.albumSelectionIdList = []
      return;
    }

    this.showProductsGrid = true
    this.productAlbumId = productAlbumId
    this.highlightedProducts.forEach(product => {
      if(product.id == productAlbumId){
        this.albumMax = product.max;
        this.albumMin = product.min;
      }
    })
  }

  // Handler for album photo selection grid
  public onAlbumItemSelected(item: any){
    if(this.albumSelectionIdList.length >= this.albumMax && this.albumSelectionIdList.indexOf(item.id) == -1){
      this.translate.get('alerts.selection_max_reached').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return;
    }

    let itemSelected = this.albumSelectionIdList.indexOf(item.id) == -1
      ? this.albumSelectionIdList.push(item.id)
      : this.albumSelectionIdList.splice(this.albumSelectionIdList.indexOf(item.id), 1)
  }

  // public toggleShowAlbumPhotos(){

  // }
  public saveAlbumSelection(){

    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })

    let rep_id;

    this.route.params.subscribe(res => {
      rep_id = res.reportage_id;
    })

    if(this.albumSelectionIdList.length < this.albumMin){
      this.translate.get('alerts.selection_min_required').subscribe((res1: string) => {
        this.translate.get('titles.list.photo').subscribe((res2: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res1 + ` ${this.albumMin} ` + res2, duration: 4000, panelClass: "error-snackbar" })
          dialogRef.close();
        })
      })
      return;
    }

    let params = {
      "product_id": this.productAlbumId,
      "photo_id_list": this.albumSelectionIdList,
      "reportage_id": rep_id
    }

    this.dataService.addAlbumToShoppingCart(params).subscribe(res => {
      
      if(res.status == 'success'){
        dialogRef.close()
        this.toggleAlbumPhotosSelector();
        this.getTotalReportageProducts(rep_id);
        this.translate.get('alerts.item_added_cart').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res , duration: 2500 })
        })
        this.updateShoppingCartBadge();
      } else {
        dialogRef.close()
        this.translate.get('alerts.product_process_error').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res , duration: 4000, panelClass: "error-snackbar" })
        })
      }
    })

  }

  public updateShoppingCartBadge(){
    this.dataService.getTotalShoppingCart().subscribe(res => {
      if (res.status == "ok") {
        this.badgeNumber = res.total_products
      }
    })
  }


}
